export const DashboardTypes = {
    GET_SCHOOL_DASHBOARD: "GET_SCHOOL_DASHBOARD",
    GET_SCHOOL_DASHBOARD_SUCCESS: "GET_SCHOOL_DASHBOARD_SUCCESS",

    GET_STUDENT_DASHBOARD: "GET_STUDENT_DASHBOARD",
    GET_STUDENT_DASHBOARD_SUCCESS: "GET_STUDENT_DASHBOARD_SUCCESS",

    ERROR: "DASHBOARD_ERROR",
};
